let sharedWorker: SharedWorker | null = null;

export const getWorkerConnection = (): SharedWorker => {
  if (!sharedWorker) {
    sharedWorker = new SharedWorker(
      new URL('./shared.worker.ts', import.meta.url),
      {
        name: 'dixa-shared-worker',
        type: 'module',
      },
    );
  }
  return sharedWorker;
};

export const resetWorkerConnection = (): void => {
  sharedWorker = null;
};
